import { validateNip as validateNipCore } from '@credistream/shared';

/**
 * Ant Design form validator for Polish NIP (tax identification number).
 * Delegates checksum logic to the shared validateNip utility.
 */
export function validateNip(_rule: unknown, value: string): Promise<void> {
  if (!value) return Promise.resolve();
  if (!validateNipCore(value)) {
    return Promise.reject();
  }

  return Promise.resolve();
}
